export default __webpack_public_path__ + "static/media/image_38.309acbc5.png";